import {
  SerializedStyles,
  Theme as EmotionTheme,
  ThemeProvider as EmotionThemeProvider,
  useTheme,
} from "@emotion/react";
import * as React from "react";

type ThemeVariant = EmotionTheme["themeVariant"];

export const chooseThemeVariant =
  (variants: Record<ThemeVariant, SerializedStyles | string | number>) =>
  ({ theme }: { theme: EmotionTheme }) => {
    return variants[theme.themeVariant || "default"];
  };

interface ThemeProviderProps
  extends Omit<React.ComponentProps<EmotionThemeProvider>, "theme"> {
  theme: ThemeVariant;
}

export const ThemeProvider = ({ theme, ...props }: ThemeProviderProps) => {
  const emotionTheme = useTheme();

  return (
    <EmotionThemeProvider
      theme={{ ...emotionTheme, themeVariant: theme }}
      {...props}
    />
  );
};

declare module "@emotion/react" {
  interface Theme {
    themeVariant: "default" | "translucent";
  }
}
